const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Suivez mes aventures autours du monde", // <title>
  shortSiteTitle: "Suivez mes aventures autours du monde", // <title> ending for posts and pages
  siteDescription: "Suivez mes aventures autours du monde",
  siteUrl: "https://travel.oyabi.fr",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "fr",
  // author
  authorName: "Thomas CAILHE",
  authorTwitterAccount: "oyabi",
  // info
  infoTitle: "Thomas CAILHE",
  infoTitleNote: "Blog personnel",
  // manifest.json
  manifestName: "Oyabi",
  manifestShortName: "Blog personnel", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "t.cailhe@gmail.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/Oyabi" },
    { name: "twitter", url: "https://twitter.com/Oyabi" },
    { name: "facebook", url: "https://www.facebook.com/Thomas.Cailhe" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js